var _path, _path2, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 58.5117C4 43.3908 16.5365 31.1339 32 31.1339C47.4635 31.1339 60 43.3908 60 58.5117",
    stroke: "#3098F3",
    strokeWidth: 8,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8047 58.5107C45.8044 51.1231 39.8154 45.1344 32.4277 45.1344C25.0401 45.1344 19.0511 51.1231 19.0508 58.5107L45.8047 58.5107Z",
    fill: "#FE6571"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.9993,
    cy: 11.8444,
    rx: 6.84444,
    ry: 6.84444,
    transform: "rotate(90 31.9993 11.8444)",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccessibility);
export default __webpack_public_path__ + "static/media/icon-accessibility.0066c45b8ac13f266206b51f28c91002.svg";
export { ForwardRef as ReactComponent };